"use client"
import ErrorModal from "../../../components/ErrorModal"

const UserValidationModal = ({ isOpen, onClose, messages }) => {
  const messageText = Array.isArray(messages) ? messages.filter(Boolean).join("\n") : (messages || "");
  return (
    <ErrorModal isOpen={isOpen} onClose={onClose} message={messageText} isSuccess={false} />
  )
}

export default UserValidationModal
